export default __webpack_public_path__ + "static/media/success-cloud.4f802ec5.svg";